module.exports = __webpack_public_path__ + "static/investments-hero.d998cd11.webp";